import { ReactNode } from 'react';
import React from 'react';

const DELIMITER = ';';

const extractText = (node: ReactNode): string => {
  if (typeof node === 'string') {
    return node;
  }

  if (typeof node === 'number') {
    return node.toString();
  }

  if (React.isValidElement(node)) {
    let text = '';
    React.Children.forEach(node.props.children, (child) => {
      text += extractText(child);
    });
    return text;
  }

  return '';
};

//csv accepts 4 delimiters by default: comma, tab, space, and semicolon - they should be escaped if used as part of value
const escapeCsvValue = (value?: unknown) => {
  return value === 0
    ? '0'
    : typeof value === 'string' || typeof value === 'number'
      ? `"${value}"`
      : Array.isArray(value)
        ? `"${value.map((val) => extractText(val as ReactNode))}"`
        : '-';
};

const getCSVFromJson = (rows: unknown[], headers: { label: string; value: string }[]) => {
  let csv = '';

  csv += headers.map((header) => escapeCsvValue(header.label)).join(DELIMITER) + '\n';

  rows.forEach((row: any) => {
    const data = headers.map((header) => escapeCsvValue(row[header.value])).join(DELIMITER);
    csv += data + '\n';
  });

  return csv;
};

export const downloadCSV = ({
  rows,
  fileName,
  headers,
}: {
  rows: object[];
  fileName: string;
  headers: { label: string; value: string }[];
}) => {
  const csvData = getCSVFromJson(rows, headers);

  if (csvData === '' || !headers.length || !rows.length) {
    //nothing to export
    return false;
  }

  const blob = new Blob([csvData], { type: `text/csv;charset=utf-8${DELIMITER}` });
  const link = document.createElement('a');

  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);

  return true;
};
